import { EditMaterialInputType } from '@shelflix/schemas/material/edit';
import { Card, CardContent, CardHeader, CardTitle } from '@shelflix/ui-web/components/ui/card';
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@shelflix/ui-web/components/ui/form';
import { Input } from '@shelflix/ui-web/components/ui/input';
import { UseFormReturn } from 'react-hook-form';
import { checkMaterialCreateInput } from '@shelflix/schemas/material/create';

interface ModemSectionProps {
  form: UseFormReturn<
    EditMaterialInputType & {
      cnpj: {
        uuid: string;
        cnpj: string;
        name: string;
      };
      materialTypeUuid: {
        uuid: string;
        name: string;
        brand: {
          name: string;
        };
      };
    }
  >;
}

export function ModemSection({ form }: ModemSectionProps) {
  return (
    <Card className="rounded-[10px]">
      <CardHeader className="pb-0">
        <CardTitle className="text-primary text-2xl leading-5 font-semibold">Modem</CardTitle>
      </CardHeader>
      <CardContent className="grid grid-cols-6 gap-4">
        <FormField
          control={form.control}
          name="modem.marca"
          rules={{ validate: (value) => checkMaterialCreateInput('modem.marca', value) }}
          render={({ field }) => (
            <FormItem className="col-span-2 flex w-full flex-col gap-[3px]">
              <FormLabel className="text-xs font-medium text-[var(--gray-primary)]">Marca</FormLabel>
              <FormControl>
                <Input className="h-[36px] w-full" placeholder="Ex: Aquário" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="modem.modelo"
          rules={{ validate: (value) => checkMaterialCreateInput('modem.modelo', value) }}
          render={({ field }) => (
            <FormItem className="col-span-2 flex w-full flex-col gap-[3px]">
              <FormLabel className="text-xs font-medium text-[var(--gray-primary)]">Modelo</FormLabel>
              <FormControl>
                <Input className="h-[36px] w-full" placeholder="Ex: Aquario 7000" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="modem.identifierNumber"
          rules={{ validate: (value) => checkMaterialCreateInput('modem.identifierNumber', value) }}
          render={({ field }) => (
            <FormItem className="col-span-2 flex w-full flex-col gap-[3px]">
              <FormLabel className="text-xs font-medium text-[var(--gray-primary)]">Número do Identificador</FormLabel>
              <FormControl>
                <Input className="h-[36px] w-full" placeholder="Ex: AQU_MF7_0001" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="modem.msisdn"
          rules={{ validate: (value) => checkMaterialCreateInput('modem.msisdn', value) }}
          render={({ field }) => (
            <FormItem className="col-span-2 flex w-full flex-col gap-[3px]">
              <FormLabel className="text-xs font-medium text-[var(--gray-primary)]">Linha</FormLabel>
              <FormControl>
                <Input className="h-[36px] w-full" placeholder="Ex: 5531987441245" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="modem.imei"
          rules={{ validate: (value) => checkMaterialCreateInput('modem.imei', value) }}
          render={({ field }) => (
            <FormItem className="col-span-2 flex w-full flex-col gap-[3px]">
              <FormLabel className="text-xs font-medium text-[var(--gray-primary)]">IMEI</FormLabel>
              <FormControl>
                <Input className="h-[36px] w-full" placeholder="Ex: 2198012982908102810" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="modem.monthlyDataLimit"
          rules={{ validate: (value) => checkMaterialCreateInput('modem.monthlyDataLimit', value) }}
          render={({ field }) => (
            <FormItem className="col-span-2 flex w-full flex-col gap-[3px]">
              <FormLabel className="text-xs font-medium text-[var(--gray-primary)]">
                Limite de Dados Mensal (GB)
              </FormLabel>
              <FormControl>
                <Input className="h-[36px] w-full" defaultValue="1" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </CardContent>
    </Card>
  );
}
